import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import CircularProgress from "@material-ui/core/CircularProgress";
import locales from "../../../_constants/locales";
import DataConflictWindow from "./_DataConflictWindow";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import FormHelperText from "@material-ui/core/FormHelperText";
import "../Styles/_ReturnOrderWindow.css";

class ReturnOrderWindow extends Component {
    constructor(props) {
        super(props);
        this.state = {
            returnReasonId: null,
            returnErrorMessage: "",
            returnFinished: false,
            submitErrors: [],
            dataConflictWindowOpen: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.loading === false && prevProps.loading === true) {
            if (!this.props.err) {
                this.setState({
                    returnFinished: true
                });
            } else {
                this.setState({
                    returnErrorMessage: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER.ERROR_FAILED
                });
            }
        }

        if (prevProps.open === false && this.props.open === true && this.props.returnReasons.length === 0 && this.props.returnReasonsLoading === false) {
            this.props.getReturnReasons();
        }

        if (prevProps.open === false && this.props.open === true) {
            this.resetErrorMessages();
            this.resetReturnReason();
            this.resetReturnFinished();
            this.resetSubmitErrors();
        }
    }

    resetReturnFinished() {
        this.setState({
            returnFinished: false
        });
    }

    handleNoClick() {
        if (this.state.returnFinished) {
            this.props.handleClose();
            this.props.getOrder(this.props.order_id);
        } else {
            this.props.handleClose();
        }
    }

    handleYesClick() {
        this.resetSubmitErrors();
        if (this.getSubmitErrors().length === 0) {
            this.props.returnOrder(
                this.props.order_id,
                {
                    order: this.props.order,
                    reason: this.state.returnReasonId
                },
                this.props.language
            );
        } else {
            this.updateSubmitErrors();
        }
    }

    updateSubmitErrors() {
        this.setState({
            submitErrors: this.getSubmitErrors()
        });
    }

    handleConfirmReturnOrder() {
        this.resetErrorMessages();
        this.handleCloseConfirmationWindow();
        this.returnOrder();
    }

    returnOrder() {
        this.props.returnOrder(this.props.order_id, this.props.language);
    }

    getSubmitErrors() {
        let errors = [];

        if (!this.state.returnReasonId) {
            errors.push({
                code: "return_reason",
                label: locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.ERRORS.REASON_REQUIRED
            });
        }

        return errors;
    }

    resetSubmitErrors() {
        this.setState({
            submitErrors: []
        });
    }

    resetErrorMessages() {
        this.setState({
            returnErrorMessage: ""
        });
    }

    handleEnter() {
        this.resetErrorMessages();
    }

    handleChange(e) {
        switch (e.target.name) {
            case "return-reason":
                this.setState({
                    returnReasonId: e.target.value
                });
                break;

            default:
                break;
        }
    }

    resetReturnReason() {
        this.setState({
            returnReasonId: null
        });
    }

    handleRefreshOrder() {
        this.props.handleClose();
        this.props.refreshOrder();
    }

    render() {
        return (
            <Dialog
                classes={{ paper: `order-return-dialog-paper${this.state.returnFinished ? " completed" : ""}` }}
                className="order-return-dialog"
                open={this.props.open || false}
                onEnter={this.handleEnter.bind(this)}
            >
                <div className={`layout vertical order-return-window relative${this.state.returnFinished ? " completed" : ""}`}>
                    <div className="order-return-window-inner">
                        <div
                            className={`loading-box fit layout vertical center-center${
                                !(this.props.loading || this.props.returnReasonsLoading) ? " hidden" : ""
                            }`}
                        >
                            <CircularProgress className="loading-progress" size={74} color="primary" thickness={6} />
                        </div>

                        <div className="box">
                            <div className="row">
                                <div className="column">
                                    <p className="title">{locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER.HEADING}</p>
                                </div>
                            </div>
                        </div>

                        {!this.state.returnFinished && (
                            <div>
                                {this.state.returnErrorMessage && (
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">{this.state.returnErrorMessage}</div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="box">
                                    <div className="row">
                                        <div className="column">
                                            <div className="sub-title">
                                                {locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER.SUBHEADING}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.props.total_egift_cards !== null && this.props.total_egift_cards > 0 && (
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div style={{ fontSize: "11px", color: "rgba(0, 0, 0, 0.54)", margin: "5px 0px 10px 0px" }}>
                                                    {
                                                        locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER
                                                            .EGIFTCARDS_PRESENT_MESSAGE
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="box">
                                    <div className="row">
                                        <div className="column">
                                            <div className="layout vertical custom-select-box">
                                                <InputLabel className={`custom-select-label`}>{`* ${
                                                    locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.REASON_HEADER
                                                }`}</InputLabel>
                                                <Select
                                                    classes={{
                                                        selectMenu: "custom-select-menu"
                                                    }}
                                                    name="return-reason"
                                                    MenuProps={{
                                                        variant: "menu",
                                                        getContentAnchorEl: null,
                                                        classes: {
                                                            paper: "custom-select-menu-paper"
                                                        }
                                                    }}
                                                    className="custom-select"
                                                    disabled={false}
                                                    value={this.state.returnReasonId || -1}
                                                    onChange={this.handleChange.bind(this)}
                                                >
                                                    {this.props.returnReasons &&
                                                        this.props.returnReasons.length > 0 &&
                                                        this.props.returnReasons.map((returnReason, i) => {
                                                            return (
                                                                <MenuItem key={i} className="form-menu-item-select-multiple" value={returnReason.id}>
                                                                    <ListItemText
                                                                        classes={{
                                                                            root: "form-menu-item-select-multiple-list-item-text"
                                                                        }}
                                                                    >
                                                                        {
                                                                            locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.REASONS[
                                                                                returnReason.code
                                                                            ]
                                                                        }
                                                                    </ListItemText>
                                                                </MenuItem>
                                                            );
                                                        })}
                                                    )
                                                </Select>
                                                {this.state.submitErrors.length > 0 && this.state.submitErrors.find(e => e.code === "return_reason") && (
                                                    <FormHelperText>{this.state.submitErrors.find(e => e.code === "return_reason").label}</FormHelperText>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="buttons-1" className="box">
                                    <div className="row">
                                        <div className="column">
                                            <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                </div>
                                            </button>
                                        </div>
                                        <div className="column">
                                            <button
                                                className={`custom-button ${this.props.loading ? "loading" : ""}`}
                                                style={{ float: "right" }}
                                                onClick={this.props.loading ? null : this.handleYesClick.bind(this)}
                                            >
                                                <div className="layout vertical center-center inbutton-text">
                                                    {locales[this.props.store[0]][this.props.language].MISC.SUBMIT}
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {this.state.returnFinished && (
                            <div>
                                <div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <div className="message-box">
                                                    {locales[this.props.store[0]][this.props.language].ORDER_PAGE.RETURN_SECTION.RETURN_ORDER.SUCCESS_MESSAGE}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box">
                                        <div className="row">
                                            <div className="column">
                                                <button className="custom-button" onClick={this.handleNoClick.bind(this)}>
                                                    <div className="layout vertical center-center inbutton-text">
                                                        {locales[this.props.store[0]][this.props.language].MISC.CLOSE}
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        <DataConflictWindow
                            open={this.state.dataConflictWindowOpen}
                            handleSubmit={this.handleRefreshOrder.bind(this)}
                            heading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.HEADING}
                            subheading={locales[this.props.store[0]][this.props.language].DATA_CONFLICT.SUB_HEADING}
                            yesText={locales[this.props.store[0]][this.props.language].MISC.REFRESH}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default withRouter(ReturnOrderWindow);



// WEBPACK FOOTER //
// ./src/views/Order/components/_ReturnOrderWindow.jsx